import {checkToLoadScriptFoOdoo, qtyProxy} from "./src/helpers/helper";
import './src/components'
import { errorMessages } from './src/assets/config';

export {qtyProxy}

// @ts-ignore

(function (){
    if (checkToLoadScriptFoOdoo()) {
        return;
    }
    window.innerWidth <= 767 && alert(errorMessages.MOBILE_ALERT);
    qtyProxy['isFormSubmiting'] = false;
    window.addEventListener("beforeunload", (event) => {
        if(qtyProxy?.isFormSubmiting) {
            return;
        } 
        event.preventDefault() ;
        event.returnValue = "";
    });
})();
